"use client";

import { Award, HeartPulse, LifeBuoy, ShieldCheck, Users, Wrench } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Trust() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const badges = [{
    icon: Award,
    title: "Certified Installers",
    desc: "Master-level craftsmanship on every project."
  }, {
    icon: LifeBuoy,
    title: "Safety First Protocol",
    desc: "Strict adherence to site safety standards."
  }, {
    icon: HeartPulse,
    title: "WCB Compliant",
    desc: "Fully insured and protected workforce."
  }, {
    icon: Users,
    title: "Dedicated Project Leads",
    desc: "Direct communication throughout the build."
  }, {
    icon: Wrench,
    title: "Premium Materials",
    desc: "Industry-leading warranties on all products."
  }, {
    icon: ShieldCheck,
    title: "Fully Licensed",
    desc: "Registered and bonded exterior specialists."
  }];
  return <section data-section-id="729" id="trustandcredibility" className="relative overflow-hidden bg-white ![padding:50px_0px_30px_0px]">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={headRef} className={`transition-all duration-700 ease-out ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="font-default text-sm font-medium uppercase tracking-[0.2em] text-orange-600">RELIABILITY</p>
            <h2 className="mt-6 font-default text-4xl font-bold leading-[1.05] tracking-tight text-gray-900 md:text-5xl lg:text-6xl">
              Excellence in Every Detail
            </h2>
            <p className="mt-8 max-w-xl font-default text-base leading-relaxed text-gray-600 md:text-lg">
              At MetalLine Exteriors, we believe your home deserves the highest standard of protection. 
              From architectural cladding to premium metal roofing, our commitment to quality ensures 
              your investment stands the test of time against Calgary's challenging climate.
            </p>
          </div>

          {}
          <div ref={gridRef} className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5">
            {badges.map((badge, i) => {
            const Icon = badge.icon;
            return <div data-index={i} key={i} className={`group rounded-lg border border-gray-200 bg-gray-50 p-6 transition-all duration-700 ease-out hover:-translate-y-1 hover:shadow-md ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
              transitionDelay: gridVisible ? `${i * 80}ms` : "0ms"
            }}>
                  <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-orange-100">
                    <Icon className="h-6 w-6 text-orange-600" strokeWidth={1.5} />
                  </div>
                  <h3 className="mt-5 font-default text-sm font-bold uppercase tracking-wider text-gray-900">
                    {badge.title}
                  </h3>
                  <p className="mt-2 font-default text-sm leading-relaxed text-gray-600">
                    {badge.desc}
                  </p>
                </div>;
          })}
          </div>
        </div>

        {}
        <div ref={statsRef} className="mt-20 border-t border-gray-200 transition-all duration-700 ease-out opacity-100 translate-y-0 ![padding:30px_0px_0px_0px] md:mt-24">
          <div className="grid grid-cols-1 gap-10 text-center sm:grid-cols-3 sm:gap-6 sm:text-left">
            <div data-index={0}>
              <div className="font-default text-5xl font-bold leading-none tracking-tight text-gray-900 md:text-6xl lg:text-7xl">
                100%
              </div>
              <div className="mt-3 font-default text-xs font-medium uppercase tracking-[0.18em] text-gray-500">
                Satisfaction
              </div>
            </div>
            <div data-index={1}>
              <div className="font-default text-5xl font-bold leading-none tracking-tight text-gray-900 md:text-6xl lg:text-7xl">
                10+
              </div>
              <div className="mt-3 font-default text-xs font-medium uppercase tracking-[0.18em] text-gray-500">
                Years Experience
              </div>
            </div>
            <div data-index={2}>
              <div className="font-default text-5xl font-bold leading-none tracking-tight text-gray-900 md:text-6xl lg:text-7xl">50+</div>
              <div className="mt-3 font-default text-xs font-medium uppercase tracking-[0.18em] text-gray-500">
                Projects Completed
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}